import React, { FC } from "react";

import { firestore } from "firebase-tools/firebase";
import useDocumentSubscriber from "hooks/useDocumentSubscriber";
import { SocialMediaPlatform } from "../SelectCampaign";
import Extractor from "components/BeAmplified/Campaigns/Organic/View/Extractor";

type CampaignType = {
  platform?: string;
  uid?: string;
  path: string;
};

const ExtractorPage: FC<CampaignType> = ({ platform, uid }) => {
  let campaignsRef: any;
  if (SocialMediaPlatform.Facebook.toUpperCase() === platform?.toUpperCase()) {
    campaignsRef = firestore.collection("facebook-group-scrapper").doc(uid);
  }
  if (SocialMediaPlatform.Instagram.toUpperCase() === platform?.toUpperCase()) {
    campaignsRef = firestore
      .collection("instagram-comments-extractor")
      .doc(uid);
  }

  const campaign = useDocumentSubscriber({ ref: campaignsRef }).document;

  const socialMediaPlatform = platform
    ? (platform as SocialMediaPlatform)
    : SocialMediaPlatform.Facebook;

  return (
    <div>
      {campaign?.status && (
        <Extractor platform={socialMediaPlatform} campaign={campaign} />
      )}
    </div>
  );
};

export default ExtractorPage;
